<template>
  <router-link :to="item.url" :class="['accordion--item', 'pt-2xl', 'px-l']">
    <h2 v-text="item.title" class="heading__3 text-gray-8"></h2>
    <h6
      class="trunc mt-xs text--s text-gray-8"
      v-if="item.sub_title"
      v-text="item.sub_title"
    ></h6>
    <img :src="accordionImage" alt="" />
    <br />
    <transition name="fade-delayed" appear>
      <div
        v-if="isActive && item.children.length"
        class="link-group flex flex-column pt-xl text-left"
      >
        <router-link
          v-for="child in item.children"
          :key="child.title"
          v-text="child.title"
          :to="child.url"
          class="text--m mb-xs text-gray-8"
        ></router-link>
      </div>
    </transition>
  </router-link>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  // mounted() {
  //   console.log("ITEM > ", this.item);
  // },
  methods: {
    parseUrl(url) {
      // console.log('parse url > ', url);
      let _url,
        locale = this.$route.params.locale;
      if (locale) {
        _url = "/" + locale + url;
      } else {
        _url = url;
      }
      // console.log("_URL > ", _url);
      return _url;
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    buttons() {
      return _.filter(this.item.children, { type: "button" });
    },
    accordionImage() {
      let image =
        this.dimensions.width < 600 && this.item.mobile_image
          ? this.item.mobile_image
          : this.item.image;
      // console.log("IMAGE > ", image, " :: ", this.image);
      return image ? `${this.$imageFolder}/${image}` : "";
    }
  }
};
</script>
<style lang="stylus" scoped>
.btn-group
	float left
.link-group
  position relative
  z-index 9
  +below(415px)
    pad('m', top)
  a
    color gray_8
      /.education &
      /.company &
      /.research_and_development &
        color gray_1
    &:hover
      color blue_5
.accordion--item
  overflow hidden
  position relative
  background gray_0
  transform translateZ(0)
  transition flex 0.6s ease-out-quad
  will-change flex
  backface-visibility hidden
  user-select none
  -webkit-tap-highlight-color transparent
  margin-bottom 20px
  width 100%
  display block
  &:active
  &:focus
    outline 0
  h2
    z-index 11
    position relative
    display inline-block
    max-width 200px
    a
      color gray_8
      /.education &
      /.company &
      /.research_and_development &
        color gray_2

      &:hover
        color blue_5
  img
    position absolute
    bottom 0
    right 0
    transform translate(25%, 0)
    transition transform 0.6s ease-out-quad, opacity 0.6s ease-out-quad
    will-change transform
    backface-visibility hidden

    /.education &
    /.company &
    /.research_and_development &
      height auto
      left 50%
      max-height 45%
      top 50%
      transform translate(-50%, -10%)
      +below(1100px)
        height 55%
        left 100%
        +landscape()
          height 120px
          transform translate(-120%, -10%)
      +below(815px)
        max-height 120px

    max-width 26vw
    +below(1400px)
      max-width 20vw
      transform translate(13%)
    +below(1100px, orientation: landscape)
      max-width 70%
      transform translate(0, 15%)
    +below(600px)
      transform translate(-30%, -20%)

    +portrait()
      max-height 100%
      transform none
      /.education &
      /.company &
      /.research_and_development &
        top auto
        left 100%
        transform translate(-120%, -20%)
        width auto
        height 150px
        max-width initial
  +below(1100px)
    flex 0 0 calc(50% - 10px)
    height 300px
  +below(815px)
    height 220px
  +portrait()
    // min-height 35vh
    pad('2xl', x)
  +below(1100px, orientation: portrait)
    pad('xl', x)
  +below(600px)
    min-height 250px
    width 100%
    flex none
    display block
    border none !important
    padding 20px
    marg('xl',bottom)
    &:last-child
      margin 0
    flex-direction row
    max-width initial
    .btn
      flex none
      marg('m',left)
    img
      max-width 60%
  +above(1101px)
    flex 1
    +landscape()
      min-height 70vh
      +above(unit($max, 'px'))
        min-height 680px
    &:not(:last-child)
      border-right 10px solid #fff
    &:not(:first-child)
      border-left 10px solid #fff
    &:hover
      flex 2.5
      img
        transform translate(0, 0)
        z-index -1
        /.education &
        /.company &
        /.research_and_development &
          transform translate(-50%, -10%)
    /* ----------- iPad Pro ----------- */
  /* Portrait and Landscape */
  @media screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1.5)
    flex 0 0 calc(50% - 10px)
    height 300px
    min-height 30vh !important
    img
      top initial !important
      left initial !important
      right 0 !important
      bottom 0 !important
      transform translate(-25px, -25px) !important

    // img
    //   transform none !important
    //   max-width 75% !important





// /* Portrait */
// @media only screen
//   and (min-device-width: 1024px)
//   and (max-device-height: 1366px)
//   and (orientation: portrait)
//   and (-webkit-min-device-pixel-ratio: 1.5) {
//     flex 0 0 calc(50% - 10px)
//     height 300px
// }

// /* Landscape */
// @media only screen
//   and (min-device-width: 1024px)
//   and (max-device-height: 1366px)
//   and (orientation: landscape)
//   and (-webkit-min-device-pixel-ratio: 1.5) {
//     flex 0 0 calc(50% - 10px)
//     height 300px

// }
</style>
